import type { Asserts } from 'yup';

import { contractSchema as kradContractSchema } from '@/features/Sparten/kradv2/schema/contractSchema';
import { genericStoreFactory } from '@/utils/genericStoreFactory/genericStoreFactory';

export const contractSchema = kradContractSchema;

export type ContractStore = Asserts<typeof contractSchema>;

export const useKradv2ContractStore = genericStoreFactory(
  () => contractSchema.getDefault() as ContractStore,
  'Kradv2ContractStore',
);
